import { useState, useMemo } from 'react'

//Styles
import Styles from './pilih-asisten-penjual.module.scss'

//Components
import TextMedium from 'pages/dashboard/e-reporting/forms/components/reuseables/text-medium'
import Order from 'pages/dashboard/e-reporting/forms/components/reuseables/order'
import WrapperAndBox from 'pages/dashboard/e-reporting/forms/components/reuseables/wrapper-and-box/WrapperAndBox'
import SelectWithSearch from 'pages/dashboard/e-reporting/forms/components/reuseables/select-with-search/SelectWithSearch'
import ButtonSelanjutnya from 'pages/dashboard/e-reporting/forms/components/reuseables/button-selanjutnya/ButtonSelanjutnya'
import ButtonSebelumnya from 'pages/dashboard/e-reporting/forms/components/reuseables/button-sebelumnya'
import BoxFlex from 'pages/dashboard/e-reporting/forms/components/reuseables/box-flex'

//Context
import { STEPS, useFormMethod, useFormState } from "pages/dashboard/e-reporting/forms/context";

//hoc
import withFetch from './withFetch'

function PilihAsistenPenjual({ data }) {
  //Context
  const { form, isAprroval, isEditing } = useFormState()
  const { setCurrentStep, formHandler, handlePrevState } = useFormMethod();

  //State
  const [selectedData, setSelectedData] = useState({
    ...form.asisten_penjual.value,
    value: form.asisten_penjual.value.id,
    label: form.asisten_penjual.value.full_name
  })

  const mappedData = useMemo(() => {
    if (!data?.length) return [];
    return data.map(datum => {
      return {
        value: datum.id,
        label: datum.full_name,
        ...datum
      }
    })
  }, [data])

  const onNext = () => {
    handlePrevState()
    formHandler('asisten_penjual', selectedData)
    setCurrentStep(STEPS.komisiPenjual)
  }

  return (
    <WrapperAndBox>
      <div className={Styles['title']}>
        <TextMedium required>
          <span className={Styles['prefix']}>(co-listing)</span> Siapa marketing penjual selain <span className={Styles['name']}>{form.marketing_penjual.value.full_name}</span>?
        </TextMedium>

      </div>
      <div className={Styles['select-wrapper']}>
        <SelectWithSearch selectedData={selectedData} disabled={isAprroval || isEditing} onClick={setSelectedData} options={mappedData} placeholder="Klik di sini atau klik simbol panah" />
        <BoxFlex>
          <>
            <ButtonSebelumnya />
            {selectedData.id !== null ? <ButtonSelanjutnya onClick={onNext} /> : null}
          </>
        </BoxFlex>
      </div>
    </WrapperAndBox>
  )
}

export default withFetch(PilihAsistenPenjual)